import {useAppContext} from "../../../contexts/AppContext";

// Л — имената, които сървърът не е разпознал еднозначно. Само тук човек взима
// решение; близките съвпадения се ПРЕДЛАГАТ, но не се прилагат сами (тихо
// закачен грешен ползвател не се вижда като счупен екран, а като грешно число
// в справка С5 месеци по-късно).

const STATUS_TEXT = {
    ambiguous: "две или повече фирми с това име — изберете коя",
    suggest: "няма точно съвпадение, но има близки",
    missing: "няма такъв ползвател в базата",
};

export const UnresolvedNames = ({unresolved, mapping, onChange}) => {
    const {companies} = useAppContext();

    if (!unresolved || unresolved.length === 0) return null;

    const options = companies.map(c => ({
        id: c.id,
        value: `${c.company_name}, ${c.bullstat}`,
    }));

    const pickFromInput = (name, value) => {
        const bullstat = String(value || "").split(",").pop().trim();
        if (/^\d+$/.test(bullstat)) onChange(name, bullstat);
    };

    return (
        <div className="mt-3" style={{
            background: "var(--app-surface-2)",
            border: "1px solid var(--app-gold)",
            borderRadius: "6px",
            padding: "12px 16px",
        }}>
            <h6 style={{color: "var(--app-gold)"}}>
                Неразпознати имена ({unresolved.length})
            </h6>
            <p className="text-muted" style={{fontSize: "0.85rem"}}>
                Посочете кой ползвател е всяко от тях или го пропуснете. Решението
                важи за всички редове с това име.
            </p>

            {unresolved.map(u => {
                const chosen = mapping[u.name];
                return (
                    <div key={u.name} className="border-top py-2">
                        <div className="d-flex justify-content-between align-items-start flex-wrap">
                            <div>
                                <strong>{u.name}</strong>{" "}
                                <span className="text-muted" style={{fontSize: "0.85rem"}}>
                                    ({u.rows} {u.rows === 1 ? "ред" : "реда"} · {STATUS_TEXT[u.status] || u.status})
                                </span>
                            </div>
                            {chosen && (
                                <span className={chosen === "skip" ? "badge bg-secondary" : "badge bg-success"}>
                                    {chosen === "skip" ? "пропуска се" : `→ булстат ${chosen}`}
                                </span>
                            )}
                        </div>

                        {u.candidates && u.candidates.length > 0 && (
                            <div className="mt-1">
                                {u.candidates.map(c => (
                                    <button key={c.bullstat} type="button"
                                            className="btn btn-sm btn-outline-primary me-2 mb-1"
                                            onClick={() => onChange(u.name, String(c.bullstat))}>
                                        {c.company_name} ({c.bullstat})
                                        {c.score !== undefined && ` · ${Math.round(c.score * 100)}%`}
                                    </button>
                                ))}
                            </div>
                        )}

                        <div className="d-flex gap-2 mt-1 flex-wrap">
                            <input className="form-control form-control-sm" style={{maxWidth: "420px"}}
                                   type="search" list={`companies-${u.name}`}
                                   placeholder="…или потърсете друг ползвател"
                                   onChange={(e) => pickFromInput(u.name, e.target.value)}/>
                            <datalist id={`companies-${u.name}`}>
                                {options.map(o => <option key={o.id} value={o.value}/>)}
                            </datalist>
                            <button type="button" className="btn btn-sm btn-outline-secondary"
                                    onClick={() => onChange(u.name, "skip")}>
                                Пропусни
                            </button>
                            {chosen && (
                                <button type="button" className="btn btn-sm btn-link"
                                        onClick={() => onChange(u.name, null)}>
                                    изчисти
                                </button>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
